import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TitleUpdater = () => {
  const location = useLocation();

  useEffect(() => {
    const pageName = getPageName(location.pathname);
    document.title = `${pageName} - דשבורד הרשת`;
  }, [location]);

  return null;
};

const getPageName = (pathname: string): string => {
  const routes: { [key: string]: string } = {
    '/': 'דף הבית',
    '/intro': 'מבוא',
    '/login': 'כניסה',
    '/register': 'הרשמה',
    '/report': 'דיווח',
    '/full-map': 'מפה מלאה',
    '/help': 'עזרה',
    '/details': 'פרטים',
    '/kindergarten-leads': 'רישום גנים',
    '/leads': 'רישום גנים', // Keep for backwards compatibility
    '/shalhavot-leads': 'רישום שלהבות',
    '/daycare-centers-leads': 'רישום מעונות',
    '/shalhavot-dashboard': 'לוח בקרה שלהבות',
    '/kindergarten-dashboard': 'לוח בקרה גנים',
    '/daycare-centers-dashboard': 'לוח בקרה מעונות',
    '/settings': 'הגדרות',
    '/donations': 'תרומות',
    '/orders': 'הזמנות',
    '/campaigns': 'קמפיינים',
    '/contact-us': 'צור קשר',
    '/kedma': 'קדמה',
    '/press-wa': 'לחץ על וואטסאפ',
    '/archive': 'ארכיון',
    '/forms': 'טפסים',
    '/staff-members': 'מורים',
    '/staff-members-book': 'ספר המורים',
    '/guid': 'מדריך',
    '/links': 'קישורים',
    '/feed': 'פיד',
    '/home': 'דף הבית',
    '/stam-checks': 'בדיקות סת"ם',
    '/test': 'בדיקה',
    '/grant-fund': 'בקשות במעגל השנה',
    '/tags': 'תגיות'
  };

  // Remove trailing slash if present
  const normalizedPath = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

  // Full path overrides (e.g. nested routes)
  if (normalizedPath === '/grant-fund/system') return 'בקשות במעגל השנה - מערכת מנהלים';

  // Split the path and get the first part (e.g., '/staff-members/123' becomes '/staff-members')
  const basePath = '/' + normalizedPath.split('/')[1];

  return routes[basePath] || 'דשבורד הרשת';
};

export default TitleUpdater;
